export default class C5FreteModel {
  public freteTipoId: number = 0;
  public nome: string = "";
  public valor: number = 0;
  public tipoEntrega: string = "";

  public static toModel(item: any): C5FreteModel {
    return {
      freteTipoId: +item.FreightTypeID,
      nome: item.Name,
      valor: +item.ServiceValue,
      tipoEntrega: item.DeliveryType
    } as C5FreteModel;
  }
}
